import { Search, Bell, X, LayoutGrid, Map as MapIcon, ShieldCheck, ArrowUpDown } from "lucide-react";
import { US_STATES } from "@/lib/usStates";

export const AMENITY_PRESETS = ["Pizza oven", "Gas hood", "Walk-in freezer", "Halal-friendly", "Kosher", "Vegan-only", "Baking equipment", "Deep fryer"];

export function BrowseFilters({
  q, setQ, city, setCity, stateFilter, setStateFilter,
  maxRate, setMaxRate, selectedAmenities, toggleAmenity,
  verifiedOnly, setVerifiedOnly,
  sort, setSort,
  onApply, onSaveAlert, savingAlert, view, setView,
}) {
  return (
    <>
      <div className="flex items-baseline justify-between flex-wrap gap-4">
        <div>
          <div className="tick-label">Marketplace</div>
          <h1 className="font-display font-black text-5xl lg:text-6xl tracking-tighter mt-2">Browse kitchens.</h1>
        </div>
        <div className="border hairline flex">
          <button
            data-testid="view-grid-btn"
            onClick={() => setView("grid")}
            className={`px-4 py-2.5 flex items-center gap-2 tick-label transition-colors ${view === "grid" ? "bg-[#FF3B30] text-white" : "text-neutral-400 hover:text-white"}`}
          ><LayoutGrid size={13} /> Grid</button>
          <button
            data-testid="view-map-btn"
            onClick={() => setView("map")}
            className={`px-4 py-2.5 flex items-center gap-2 tick-label transition-colors ${view === "map" ? "bg-[#FF3B30] text-white" : "text-neutral-400 hover:text-white"}`}
          ><MapIcon size={13} /> Map</button>
        </div>
      </div>

      <div className="mt-8 grid md:grid-cols-4 gap-3">
        <div className="md:col-span-2 relative">
          <Search size={16} className="absolute left-3 top-4 text-neutral-500" />
          <input
            data-testid="search-q"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Keywords · pizza oven, halal, prep space..."
            className="w-full border hairline pl-9 pr-4 py-3 focus:outline-none focus:border-[#FF3B30]"
          />
        </div>
        <input
          data-testid="search-city"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="City"
          className="border hairline px-4 py-3 focus:outline-none focus:border-[#FF3B30]"
        />
        <select
          data-testid="search-state"
          value={stateFilter}
          onChange={(e) => setStateFilter(e.target.value)}
          className="border hairline px-4 py-3 focus:outline-none focus:border-[#FF3B30]"
        >
          <option value="">All states</option>
          {US_STATES.map((s) => (<option key={s.code} value={s.code}>{s.code} · {s.name}</option>))}
        </select>
        <input
          data-testid="search-max-rate"
          value={maxRate}
          onChange={(e) => setMaxRate(e.target.value)}
          placeholder="Max $/hr"
          type="number"
          className="border hairline px-4 py-3 focus:outline-none focus:border-[#FF3B30]"
        />
      </div>

      <div className="mt-4 flex flex-wrap gap-2" data-testid="amenity-chips">
        {AMENITY_PRESETS.map((a) => {
          const on = selectedAmenities.includes(a);
          return (
            <button
              key={a}
              type="button"
              data-testid={`amenity-chip-${a.replace(/\s+/g, "-").toLowerCase()}`}
              onClick={() => toggleAmenity(a)}
              className={`px-3 py-1.5 text-xs uppercase tracking-widest border transition-colors ${on ? "bg-[#FF3B30] text-white border-[#FF3B30]" : "border-white/10 text-neutral-400 hover:border-[#FF3B30] hover:text-white"}`}
            >
              {a}{on && <X size={11} className="inline ml-1.5" />}
            </button>
          );
        })}
      </div>

      <div className="mt-4 flex flex-wrap gap-3 items-center">
        <button data-testid="search-submit" onClick={onApply} className="btn-signal">Apply filters</button>
        <button
          data-testid="verified-only-toggle"
          type="button"
          onClick={() => setVerifiedOnly(!verifiedOnly)}
          aria-pressed={verifiedOnly}
          className={`inline-flex items-center gap-2 px-4 py-3 border transition-colors ${verifiedOnly ? "bg-[#FF3B30] border-[#FF3B30] text-white" : "border-white/10 text-neutral-400 hover:text-white hover:border-[#FF3B30]"}`}
        >
          <ShieldCheck size={14} strokeWidth={2.4} />
          <span className="tick-label">Verified hosts only</span>
        </button>
        <div className="inline-flex items-center gap-2 border hairline px-3 py-2">
          <ArrowUpDown size={13} className="text-neutral-500" />
          <span className="tick-label text-neutral-500">Sort</span>
          <select
            data-testid="sort-select"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="bg-transparent focus:outline-none tick-label"
          >
            <option value="">Newest first</option>
            <option value="verified">Verified first</option>
          </select>
        </div>
        <button
          data-testid="save-alert-btn"
          onClick={onSaveAlert}
          disabled={savingAlert}
          className="btn-outline inline-flex items-center gap-2 disabled:opacity-50"
        >
          <Bell size={13} /> {savingAlert ? "..." : "Save this search"}
        </button>
      </div>
    </>
  );
}
